const SkeletonBlock = ({ className }: { className: string }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

export const RecentSalesSkeleton = () => {
  return (
    <div className="rounded-xl bg-white/80 border p-4 shadow-sm overflow-x-auto">
      {/* Header Skeleton */}
      <div className="flex justify-between items-center mb-4">
        <SkeletonBlock className="h-5 w-32" />
        <SkeletonBlock className="h-4 w-40" />
      </div>

      {/* Table Skeleton */}
      <table className="w-full text-sm min-w-[500px]">
        <thead className="border-b">
          <tr>
            <th className="py-2">
              <SkeletonBlock className="h-4 w-20" />
            </th>
            <th className="py-2">
              <SkeletonBlock className="h-4 w-16" />
            </th>
            <th className="py-2">
              <SkeletonBlock className="h-4 w-28" />
            </th>
            <th className="py-2">
              <SkeletonBlock className="h-4 w-14" />
            </th>
          </tr>
        </thead>

        <tbody>
          {Array.from({ length: 4 }).map((_, i) => (
            <tr key={i} className="border-b last:border-none">
              <td className="py-3">
                <SkeletonBlock className="h-4 w-36" />
              </td>
              <td className="py-3">
                <SkeletonBlock className="h-4 w-20" />
              </td>
              <td className="py-3">
                <SkeletonBlock className="h-6 w-24 rounded-full" />
              </td>
              <td className="py-3">
                <SkeletonBlock className="h-4 w-24" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecentSalesSkeleton;
